import React from 'react';
import CrossRoad from "../UI/Crossroad";

const CrossRoad1CBlueConnectors = () => <CrossRoad coords="1083.000000, 1044.000000"/>;
export default CrossRoad1CBlueConnectors;